'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { fetchPublishedCollections } from '../clients/ecosystemClient';
import { maybeEarlyRequest } from '../utils/earlyRequests';
import * as ActionTypes from './ActionTypes';
export const getCollections = (isAdminPreview, previewCollectionId) => dispatch => {
  dispatch({
    type: ActionTypes.COLLECTIONS_REQUESTED
  });
  const request = maybeEarlyRequest('self-serve-collections', () => fetchPublishedCollections(isAdminPreview));
  return request.then(({
    collections
  }) => {
    const mergedCollectionListings = collections.map((_ref) => {
      let {
        id: collectionId,
        publishedListing,
        draftListing
      } = _ref,
          rest = _objectWithoutPropertiesLoose(_ref, ["id", "publishedListing", "draftListing"]);

      const isCollectionAdminPreview = isAdminPreview && previewCollectionId === `${collectionId}`;
      const listing = isCollectionAdminPreview ? draftListing : publishedListing;

      if (!listing) {
        return null;
      }

      return Object.assign({
        collectionId
      }, rest, {}, listing || {});
    }).filter(mergedCollection => !!mergedCollection).sort((a, b) => {
      const {
        createdAt: aCreatedAt = 0
      } = a;
      const {
        createdAt: bCreatedAt = 0
      } = b;

      if (aCreatedAt > bCreatedAt) {
        return 1;
      } else if (aCreatedAt < bCreatedAt) {
        return -1;
      }

      return 0;
    });
    dispatch({
      type: ActionTypes.COLLECTIONS_RECEIVED,
      payload: mergedCollectionListings
    });
    return mergedCollectionListings;
  }).catch(error => {
    dispatch({
      type: ActionTypes.COLLECTIONS_FAILED,
      payload: error
    });
    throw error;
  });
};